import { ColumnConfig, ColumnConfigOptions, ConditionalExtractor, ExtractAndFormatExtractor, LodashExtractor, LodashSeriesEnricherMapper, LodashSeriesMapper, MappedValueFormatter, NumberFormatter, TabConfig, TablePerPortfolioSeriesExtractorConfig } from '@ddt-web/data-service';

import { FAMILY_COLUMN_CONFIG, MODEL_FAMILY_COLUMN_CONFIG } from './family-column.config';

export const MODELS_SLIDER_CONFIG = new TabConfig(
	'model.slider',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesEnricherMapper(['families'], ['families'], 'families.models', (portfolio: any, data: any) => {
			return { ...portfolio, managementType: portfolio?.managementType || data?.families?.managementType };
		}),
		null,
		[
			ColumnConfig.create({
				id: 'id',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'portfolioId',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'shortName',
				extractor: new ConditionalExtractor(
					model => model.managementType === 'research' && model.pkg !== 'ACT-LAM',
					new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
					new LodashExtractor('shortName', '')
				),
				visible: true
			} as ColumnConfigOptions<ConditionalExtractor>),
			ColumnConfig.create({
				id: 'riskProfile',
				extractor: new LodashExtractor('riskProfile', ''),
				labelFormatter: new MappedValueFormatter({
					'conservative': 'Conservative',
					'moderate_conservative': 'Moderate Conservative',
					'moderate': 'Moderate',
					'moderate_aggressive': 'Moderate Aggressive',
					'aggressive': 'Aggressive'
				})
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				id: 'dasModelOrder',
				extractor: new LodashExtractor('dasModelOrder', '')
			} as ColumnConfig<LodashExtractor>),
			ColumnConfig.create({
				id: 'groups',
				extractor: new LodashExtractor('groups', '')
			} as ColumnConfig<LodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);

export const MODELS_OVERVIEW_CONFIG = new TabConfig(
	'model.slider.overview',
	null,
	new TablePerPortfolioSeriesExtractorConfig(
		new LodashSeriesMapper(['familyOverview'], 'familyOverview.models'),
		null,
		[
			ColumnConfig.create({
				id: 'id',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),

			ColumnConfig.create({
				id: 'estimatedRisk',
				extractor: new LodashExtractor('risk.total', ''),
				labelFormatter: NumberFormatter.create({ suffix: NumberFormatter.PERCENT, multiplier: 100 })
			} as ColumnConfigOptions<LodashExtractor>)
		],
		MODEL_FAMILY_COLUMN_CONFIG
	));

